module.exports = __webpack_public_path__ + "static/media/mail.2b0e5932.svg";